// Whether this admin still needs to complete 2FA - a server-side check against
// admin_users.last_2fa_verification (same monthly-reset policy as customer
// logins in my-app), not a client-side flag. The old sessionStorage version
// was itself a deliberate workaround for a real bug in an even older DB-backed
// version: the browser's own Supabase client writing the timestamp directly
// could silently affect zero rows under certain session-timing conditions.
// This version sidesteps that entirely - the write only ever happens
// server-side (backend/routes/otp.js, service-role key), never from the
// browser, so there's no browser session-timing involved for it to race with.
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:4000';

export async function needs2FA(userEmail) {
  if (process.env.REACT_APP_DISABLE_OTP === 'true') return false;
  try {
    const { data } = await axios.post(`${BACKEND_URL}/api/2fa-status`, { email: userEmail.toLowerCase() });
    return !data?.verified;
  } catch (error) {
    console.error('2FA status check failed:', error);
    return true; // fail closed - a broken check must not skip 2FA
  }
}
